export default {
  "layout": {
    "rows": [
      {
        "fields": [ { "name": "task.name" } ]
      },
      {
        "fields": [ { "name": "task.description" } ]
      }
    ]
  }
}
